// Router Surveys
export default [
  {
    path: '/lgpr/survey/:id',
    name: 'lgprSurvey',
    component: () => import(/* webpackChunkName: "stakeholders" */ '../../views/stakeholders/survey/lgpr/LgprSurvey.vue'),
  },
  {
    path: '/feed-forward/:id',
    name: 'feedforwardSurvey',
    component: () => import(/* webpackChunkName: "stakeholders" */ '../../views/stakeholders/survey/feedforward/FeedforwardMain.vue'),
  },
  {
    path: '/supporter/:id/opt-out',
    name: 'optOut',
    component: () => import(/* webpackChunkName: "stakeholders" */ '../../views/stakeholders/optOut/OptOutMain.vue'),
  },
  {
    path: '/pulse-survey/:id',
    name: 'pulseSurvey',
    component: () => import(/* webpackChunkName: "stakeholders" */ '../../views/stakeholders/survey/pulse/PulseMain.vue'),
  },
  {
    path: '/pulse-survey/',
    name: 'pulseSurveyLeader',
    component: () => import(/* webpackChunkName: "stakeholders" */ '../../views/stakeholders/survey/pulse/PulseMain.vue'),
  },
  {
    path: '/cvc-survey/:id',
    name: 'cvcSurvey',
    component: () => import(/* webpackChunkName: "stakeholders" */ '../../views/surveys/cvc/CvcMain.vue'),
  },
];
